import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button/index.js';
import { IconCategoryValue } from '../icon-category-value/index.js';
import { i18n } from '../../i18n/translate.js';

var SelectedItemsRibbon = function SelectedItemsRibbon(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      onClearSelection = _ref.onClearSelection,
      tooltip = _ref.tooltip,
      warning = _ref.warning,
      icon = _ref.icon;
  count = count || 0;

  if (count === 0 && !warning && !tooltip) {
    return null;
  }

  var children;

  if (warning) {
    children = /*#__PURE__*/React.createElement(IconCategoryValue, {
      color: "blue",
      icon: "triangle-exclamation",
      value: warning,
      tooltip: tooltip
    });
  } else {
    children = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconCategoryValue, {
      color: "blue",
      icon: icon,
      category: i18n.t('Selected Items'),
      value: count.toLocaleString('en'),
      tooltip: tooltip
    }), count > 0 && onClearSelection && /*#__PURE__*/React.createElement(Button, {
      label: i18n.t('Unselect All'),
      style: "link",
      onClick: onClearSelection
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "selected-items-ribbon"
  }, children);
};

SelectedItemsRibbon.displayName = "SelectedItemsRibbon";
SelectedItemsRibbon.propTypes = {
  count: PropTypes.number,
  icon: PropTypes.string,
  warning: PropTypes.string,
  tooltip: PropTypes.string,
  onClearSelection: PropTypes.func
};
export { SelectedItemsRibbon };